import "../../FhTag.css";
import { computed, useSlots, ref, onMounted, openBlock, createElementBlock, normalizeClass, createVNode, withCtx, renderSlot, mergeProps, unref, createTextVNode, createCommentVNode } from "vue";
import FhText from "../FhText/FhText.mjs";
import FhIcon from "../FhIcon/FhIcon.mjs";
import FhVisuallyHidden from "../FhVisuallyHidden/FhVisuallyHidden.mjs";
import close from "../../icons/close.mjs";
import { _ as _export_sfc } from "../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "FhTag",
  props: {
    dismissible: {
      type: Boolean,
      default: false
    }
  },
  emits: ["dismiss"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const computedClasses = computed(() => [
      "fh-tag",
      props.dismissible && "fh-tag--dismissible"
    ]);
    const slots = useSlots();
    const slottedContent = ref("");
    const dismiss = () => {
      emit("dismiss");
    };
    onMounted(() => {
      if (!slots.default || slots.default().length === 0) {
        console.warn("FhTag component requires default slot content.");
        return;
      }
      slottedContent.value = slots.default().map((item) => item.children).join();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(computedClasses.value)
      }, [
        createVNode(FhText, {
          variant: "body-sm",
          tag: "span",
          class: "fh-tag-content",
          title: slottedContent.value
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ]),
          _: 3
        }, 8, ["title"]),
        props.dismissible ? (openBlock(), createElementBlock("button", mergeProps({
          key: 0,
          type: "button",
          class: "fh-tag-dismiss",
          onClick: dismiss
        }, _ctx.$attrs), [
          createVNode(FhIcon, {
            icon: unref(close),
            variant: "plain",
            size: "xs"
          }, null, 8, ["icon"]),
          createVNode(FhVisuallyHidden, null, {
            default: withCtx(() => [
              createTextVNode("Remove "),
              renderSlot(_ctx.$slots, "default", {}, void 0, true)
            ]),
            _: 3
          })
        ], 16)) : createCommentVNode("", true)
      ], 2);
    };
  }
});
const FhTag = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-86cac059"]]);
export {
  FhTag as default
};
//# sourceMappingURL=FhTag.mjs.map
